import { LocaleUtil } from "@eres/core";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { Contract } from "./contract";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { AttachmentInfo } from "./tenant";

export enum EjariPropertyStatus {
	VACANT = 0,
	PENDING = 1,
	RENTED = 2,
}

export enum EjariContractStatus {
	PENDING = 1,
	ACTIVE = 2,
	TERMINATED = 3,
	COMPLETED = 4,
	CANCELED = 5,
	PASS_AUDIT = 6,
	UNDER_AUDIT = 5,
}

export enum EjariContractNormalisedStatus {
	PENDING = 1,
	ACTIVE = 2,
	TERMINATED = 3,
	RENEWED = 4,
	CANCELED = 5,
	UNDER_AUDIT = 6,
	PASS_AUDIT = 7,
	TERMINATION_REQUESTED = 8,
}

export enum EjariTenantType {
	PERSON = 1,
	COMPANY = 2,
}

export enum EjariPropertyType {
	VILLA = 4,
	UNIT = 2,
	LAND = 0,
	BUILDING = 1,
	COMPOUND = 3,
	VIRTUAL_VILLA = 5,
}

export interface Lease {
	Identity: number,
	PropertiesDataId: number,
	ContractId: number,
	ContractTypeId: number,
	ContractNumber: string,
	ContractStartDate: Date,
	ContractEndDate: Date,
	GraceStartDate: Date,
	GraceEndDate: Date,
	ContractAmount: number,
	ContractRank: number,
	ContractTenantNameEn: string,
	ContractTenantNameAr: string,
	ManagementCompanyId: number,
	TotalCount: number,
	ContractStatusId: number,
	ContractStatusNameEn: string,
	ContractStatusNameAr: string,
	ContractTenantMobile: string,
	ContractTenantUNumber: number,
	ContractTenantEmiratesId: string,
	ContractTenantId: number,
	IsSublease: number,
	Properties: EjariProperty[],
	PassportNo: string,
	PassportIssueDate: Date,
	PassportExpiryDate: Date,
	TenantParticipantId: Number,
	LicenseStateId: number,
	LicenseTypeId: number,
	LicenseNumber: number,
	InitialApprovalNumber: number,
	LicenseIssueDate: Date,
	LicenseExpiryDate: Date,
}

export interface BaseEjariProperty {
	PropertyId: number;
	PropertyIdKey?: string;
	PropertyTypeId: number;
	PropertyNumber: string;
	UnitNo: string;

	TabuPropertyId: number;
	TabuPropertyTypeId: number;
	TabuPropertySubTypeId: number;

	IsFreeHold: boolean;
	IsRented: boolean;

	MakaniNumber: string;
	Size: string;
	Dewa: string;
	Rank: string;

	AssociatedContracts?: BaseEjariContract[];
	ContractStartDate: string;
	ContractEndDate?: string;
	ContractAmount?: string;
	ContractNumber?: string;
	ContractTypeId?: string;
	ContractId?: string;
	CurrentContract: BaseEjariContract;

	ManagementCompanyId: number;
	AssociatedManagementContract?: ManagementContract;

	AssociatedDewaAccounts?: DewaAccount[];
	Owners: EjariOwner[];


	EstimatedValue?: number;
	GeneralFund?: number;
	ReserveFund?: number;
	ChargePrSqft?: number;
	ChargePrSqm?: number;
	TotalCharges?: number;
	ApplicableArea?: number;

	RentalIndexMin?: number;
	RentalIndexMax?: number;
	Rooms?: string;

	IndexRoomType?: string;
	IndexAreaId?: string;
	IndexSubAreaId?: string;

	LandAreaId?: number;
	Identity?: number;
}

export interface ApiEjariProperty extends BaseEjariProperty {

	UnitEjariPropertyId: string;
	VillaEjariPropertyId: string;
	BuildingEjariPropertyId: string;
	LandEjariPropertyId: string;

	LandPropertyId: number;
	LandPropertyIdKey?: string;
	BuildingPropertyId: number;
	BuildingPropertyIdKey?: string;
	VillaPropertyId: number;
	VillaPropertyIdKey?: string;
	UnitPropertyId: number;
	UnitPropertyIdKey?: string;

	LandNo: string;
	LandSubNo: string;

	LandDmNo: string;
	LandDmSubNo: string;

	UsageNameAr: string;
	UsageNameEn: string;

	TenantNameAr: string;
	TenantNameEn: string;

	EjariPropertyUsageId?: number;

	EjariUsageId?: number;
	EjariUsageNameEn?: string;
	EjariUsageNameAr?: string;

	EjariTypeId?: number;
	EjariTypeNameEn?: string;
	EjariTypeNameAr?: string;

	EjariSubTypeId?: number;
	EjariSubTypeNameEn?: string;
	EjariSubTypeNameAr?: string;

	LandTypeId: number;
	LandTypeNameEn?: string;
	LandTypeNameAr?: string;


	BuildingNameEn: string;
	BuildingNameAr: string;
	AreaEn: string;
	AreaAr: string;


	Latitude?: string;
	Longitude?: string;
	MoreData: string;


	ContractStatus?: number;
	ContractStatusName?: LocaleValue;
}

export interface EjariProperty extends ApiEjariProperty {
	PropertyType: EjariPropertyType;
	TenantName?: LocaleUtil.LocaleValue;
	BuildingName?: LocaleUtil.LocaleValue;
	Area?: LocaleUtil.LocaleValue;
	Usage?: LocaleUtil.LocaleValue;
	EjariUsage?: LocaleUtil.LocaleValue;
	EjariType?: LocaleUtil.LocaleValue;
	EjariSubType?: LocaleUtil.LocaleValue;
	LandType?: LocaleUtil.LocaleValue;
	EjariPropertyId: number;
	LandNumber: string;
	LandDMNumber: string;
	Location?: {
		Latitude: number;
		Longitude: number;
	};
	hasMore: boolean;
	RowValue?: string;
}

export interface DewaAccount {
	Iscommon?: boolean;
	AccountNumber: string;
}

export interface EjariOwner {
	OwnerId: number;
	OwnerNumber: number;
	OwnerNameEn: string;
	OwnerNameAr: string;
	OwnerMobile: string,
	OwnerEmiratesId: string;
	OwnerPartId: number;
	OwnerPassportNumber: string;
	OwnerCountryId: number;
	OwnerName?: LocaleValue;
}

export interface BaseEjariContract extends Contract {
	ContractStatus: EjariContractStatus;
	ContractNumber: string;
	ContractKey?: string;
	ContractStatusName?: LocaleUtil.LocaleValue;
	ContractStatusNameEn?: string;
	ContractStatusNameAr?: string;

	ContractTenantMobile: string;
	ContractTenantEmail: string;
	ContractTenantEmiratesId: string;
	LicenseNumber: string;
	ContractTenantId: number;
	ContractTenantUNumber: string;
	PaidSecurityDeposit?: number;
}

export interface ManagementContract {
	ManagementContractId: number;
	McContractNumber: string;
	CompanyName?: LocaleUtil.LocaleValue;
	Status?: LocaleUtil.LocaleValue;
	ContractType?: LocaleUtil.LocaleValue;
	CompanyNameEn?: string;
	CompanyNameAr?: string;
	McStatusNameEn?: string;
	McStatusNameAr?: string;
	McTypeNameEn?: string;
	McTypeNameAr?: string;
	McTypeId: number;
	McStartDate?: string;
	McEndDate?: string;
	CompanyLicenseNumber: string;
}

export interface LeaseResponse {
	Leases: any[];
	SubLeases: any[];
	rawSubLease: any[];
}


export interface EjariResponse<T> {
	Code: string;
	Message: string;
	Response: T & ValidationContainer;
	responseCode? : string;
}

export interface ErrorData {
	Code?: number;
	Message: LocaleValue;
}

export interface ValidationContainer {
	ValidationErrors?: number[];
	Errors?: number[] | ErrorData[];
}

export interface ApiLookup extends LookupLike {
	$id: string;
	DBAction: number;
	Identity: number;
	IsActive: boolean;
	IsDeleted: number;
	NameAr: string;
	NameEn: string;
	IsMandatory: number;
	MaxPages: number;
	MaxSizeKb: number;
	DescriptionEn: string;
	DescriptionAr: string;
}

export interface LookupLike {
	[ key: string ]: string | number | boolean;
}

export interface Lookup extends LocaleValue {
	Id: number;
	ParentId?: number;
	Children?: Lookup[];
}

export interface TenantDocumentLookup extends LocaleValue {
	Id: number;
	IsMandatory?: number;
	MaxPages?: number;
	MaxSizeKb?: number;
	Docs?: AttachmentInfo[];
}

export interface PropEditDataModel {
	AssociatedDewaAccounts?: DewaAccount[];
	PropertyTypeId?: number;
	ActiveUserType?: number;
	EjariPropertyId?: number;
	HoldType?: boolean;
	PropertyId?: number;
	ManagementCompanyId?: number;
	PrimaryOwnerParticipantId?: number;
	ActiveUserID?: string;
	PropertyUsageId?: number;
	EjariPropertyTypeId?: number;
	EjariPropertySubTypeId?: number;
}

export interface ValidatePropertyRequest {
	ActiveUserType: number;
	PropertyTypeId: number;
	OwnerParticipantId: number;
	ActiveUserID: number;
	PropertyId: number;
	ManagementCompanyId: number;
	HoldType: 0 | 1;
}

export interface ValidatePropertyResponse {
	PropertiesList: EjariProperty[];
	IsCommercialProperty: boolean;
	AllowedCoTenants?: number;
}

export interface TenantUserProfile {
	Identity: number;
	ParticipantId: number;
	ActiveIntegrationUserTypeId: number;
	ValidationError: number[];
}

export enum TenantDocTypes {
	IMAGE = 1,
	PDF = 2,
}

export function getTenantDocType( doc: AttachmentInfo ) {
	let type = TenantDocTypes.PDF;
	let fileUrl = doc.DocumentURL;
	let localData = doc.LocalData;
	if ( fileUrl && !isEmptyStringOrNull( fileUrl ) ) {
		fileUrl = fileUrl.toLocaleLowerCase();
		if ( fileUrl.endsWith( ".png" ) || fileUrl.endsWith( ".jpg" ) )
			type = TenantDocTypes.IMAGE;
	} else if ( localData && !isEmptyStringOrNull( localData ) ) {
		const d = localData.split( ";" )[ 0 ];
		if ( d.includes( "image" ) )
			type = TenantDocTypes.IMAGE;
	}
	return type;
}

export interface RentalRangePropertyRequest {
	propertyId: string;
	propertyTypeId: string;
	isFreeHold: boolean;
	contractEndDate: string;
	contractAmount?: string;
}

export interface RentalRangeProperty {
	AreaName: string;
	ErrorMsg: string;
	MaxValue: any;
	MinValue: any;
	Note: string;
	RateType: string;
	RentalType: string;
	Rentalcategory: string;
	Result: string;
	Result1: string;
}

export enum EjariPropertyUsage {
	RESIDENTIAL = 1,
	COMMERCIAL = 2,
	INDUSTRIAL = 3,
}
